// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionButton_container__3Hq-w","isMobile":"SectionButton_isMobile__3cz6w","text":"SectionButton_text__1Kofh","iconArrow":"SectionButton_iconArrow__2NL8E"};